

export function stringifyArgument(arg: any): string {
    const asString = arg?.toString();
    const type = typeof arg;

    if (type !== 'object') {
        return `{type=${type}, value=${asString}}`
    }

    let asJson: string;
    try {
        asJson = JSON.stringify(arg)
    } catch {
        asJson = 'JSON.stringify ERROR'
    }
    return `{type=${type}, value=${asJson}}`
}